import { LucideProps } from 'lucide-react'

const HalfCircle = (props: LucideProps) => (
  <svg
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.5078 0.000514258C40.439 0.000171555 40.3702 0 40.3013 0C18.0435 0 0 17.9086 0 40C0 62.0914 18.0435 80 40.3013 80C40.3702 80 40.439 79.9998 40.5078 79.9995V61.9857C40.4387 61.9863 40.3695 61.9866 40.3003 61.9866C28.0349 61.9866 18.0918 52.1179 18.0918 39.9441C18.0918 27.7704 28.0349 17.9017 40.3003 17.9017C40.3695 17.9017 40.4387 17.902 40.5078 17.9026V0.000514258Z"
      fill="#DB4245"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.1602 79.9995C40.229 79.9998 40.2978 80 40.3667 80C62.6245 80 80.668 62.0914 80.668 40C80.668 17.9086 62.6245 6.06377e-06 40.3667 4.13248e-06C40.2978 4.12651e-06 40.229 0.000171967 40.1602 0.000515284L40.1602 18.0143C40.2293 18.0137 40.2984 18.0134 40.3677 18.0134C52.6331 18.0134 62.5762 27.8821 62.5762 40.0559C62.5762 52.2296 52.6331 62.0983 40.3677 62.0983C40.2984 62.0983 40.2293 62.098 40.1602 62.0974L40.1602 79.9995Z"
      fill="#F1C2C2"
    />
  </svg>
)

export default HalfCircle
